import { ChainId, FactoryVersion } from '@nominex/nomiswap-sdk'
import { tokens } from 'config/tokens'
import { serializeFarm } from './helpers'
import { SerializedFarmConfig } from './types'

const farms: SerializedFarmConfig[] = [
  /**
   * NMX farms
   */
  {
    pid: 1,
    token: tokens[ChainId.BSC].nmx,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xA5F2f22d3b4FcCf0fEe429e6a8AcFc376F5AFa22',
    stakingServiceAddress: '0x2D8b192eAd2f402867323B072D143d44435EDd74',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 2,
    token: tokens[ChainId.BSC].nmx,
    quoteToken: tokens[ChainId.BSC].bnb,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x596f619600Da38acE164C9FAceE730c6dbE83C86',
    stakingServiceAddress: '0x5cd67d65Ff07D5BE2488E51F1a8C69273D258338',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 3,
    token: tokens[ChainId.BSC].nmx,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x01Ddfc73488eEBBf6D57EdAb4697a23897b93Ca2',
    stakingServiceAddress: '0x857083580AeD7b5726860937EF030ED8072BC9aB',
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 4,
    token: tokens[ChainId.BSC].nmx,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xdFB9cAb9f44355963588bc26b9633996Ce8c0D80',
    stakingServiceAddress: '0x10298Be5Abf74D111D133dc3493Dc4C6a9FD924b',
    finished: false,
    version: FactoryVersion.V1,
  },
  // Other farms
  {
    pid: 100,
    token: tokens[ChainId.BSC].bnb,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xe2Bbf54Dc0ccDD0Cf6270f2aF2f62FF79903Bb27',
    stakingServiceAddress: '0x8326E22a36486ae7D4B85e8DFA732527b962805c',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 101,
    token: tokens[ChainId.BSC].busd,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x8E50d726e2ea87a27fA94760D4e65d58C3aD8b44',
    stakingServiceAddress: '0x281e60407b095b956a6A5ac98EE217BEf3144928',
    finished: true,
    version: FactoryVersion.V1,
    migrateTo: 201,
  },
  {
    pid: 102,
    token: tokens[ChainId.BSC].usdc,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xfC3a2AEfF7141D6ce7C2AfB2db6a9e676C2E18A7',
    stakingServiceAddress: '0xd8925c88B94513be760AD88BC10D780d58fA001D',
    finished: true,
    version: FactoryVersion.V1,
    migrateTo: 202,
  },
  {
    pid: 103,
    token: tokens[ChainId.BSC].btcb,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xa830F3A087c9A642694f6eEa98778e1c70097754',
    stakingServiceAddress: '0xA937Eddfd12930F758788BcC936B4762BDE9d54C',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 104,
    token: tokens[ChainId.BSC].eth,
    quoteToken: tokens[ChainId.BSC].bnb,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x13dE257cb86a08753Df938b6ad30d1A456A863e6',
    stakingServiceAddress: '0xab2f4297E7e31638eBE8362471b3038018A106D8',
    created: new Date(2022, 0, 13).getTime(), // Don't forget that january = 0, february = 1, etc.
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 105,
    token: tokens[ChainId.BSC].toncoin,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xDeB1ceFa9bb596A189f76C94FDB0352D5aC736b9',
    stakingServiceAddress: '0x5c317770bf9A7d7cC88974A97fFA92C209669bFE',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 106,
    token: tokens[ChainId.BSC].sol,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x5C551CA8F00E09888F0FD57C7f91CB420ad29999',
    stakingServiceAddress: '0x26804231a528c894AB6790530b237449a817da6A',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 107,
    token: tokens[ChainId.BSC].matic,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x996B28Dda11381466C9e410D0b63a313a0f31c6B',
    stakingServiceAddress: '0x63A81d936cb14fA3649A4D071608758cFFb3Bd94',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 108,
    token: tokens[ChainId.BSC].doge,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xDCbc1D9D48016b8d5F3B0F9045Eb3B72F38E6B93',
    stakingServiceAddress: '0xA0F2C13e20A11e00acF4e7B47604b24ca8908797',
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 109,
    token: tokens[ChainId.BSC].shib,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x943B50018F1A8aa16ce24503eef3E53115103fb6',
    stakingServiceAddress: '0x03868d2e45a9b579Cc68B7addd65Cf78Ddb62a68',
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 110,
    token: tokens[ChainId.BSC].eth,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xe324aa41eeFd912421C601626A6D5F85CC346B6a',
    stakingServiceAddress: '0xa932e21b48103C7B2C257069d8001d38C2E854f8',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 111,
    token: tokens[ChainId.BSC].eth,
    quoteToken: tokens[ChainId.BSC].btcb,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xEAD6bDAb1B9fC66c9a1C0e647674845971f57032',
    stakingServiceAddress: '0x63569dFea4cb639E5EF134EA66C3d00b4BA43379',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 112,
    token: tokens[ChainId.BSC].bnb,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x33edc4c558c4bADFe050d79F565632CF910573B6',
    stakingServiceAddress: '0x6dF6F67a0b5D155919731131E86BF0e3Fcc1cCae',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 113,
    token: tokens[ChainId.BSC].bnb,
    quoteToken: tokens[ChainId.BSC].btcb,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x36451A95D5a2F0C25530331F382E4D432CAecB17',
    stakingServiceAddress: '0xE5F3d160702Cc1471092F45bB1725E4265BFFFE7',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 114,
    token: tokens[ChainId.BSC].trx,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x2FEBb4fB46B517d56238cf4Ee9E65Bd46e593079',
    stakingServiceAddress: '0x3C1beD72665049f8E83339D20B4D2bd9027f3496',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 115,
    token: tokens[ChainId.BSC].link,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xE7b2D08e7CD3270Df7FF804786F444434ff7E1F6',
    stakingServiceAddress: '0x1aCb5B0c772f11E825352344EB147910182bbB87',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 116,
    token: tokens[ChainId.BSC].ada,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x325E05AFc5912f62c96c87a6FE51a420b567528B',
    stakingServiceAddress: '0x14340F2b365439F47cD74b562FFAF6469dB6F923',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 117,
    token: tokens[ChainId.BSC].dot,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xE1634A309516a4f4Ad33Bdc321Dc0a5C9fF5E325',
    stakingServiceAddress: '0x2B2B75a28c84a44d7BbFC5093f756A65397E53f9',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 118,
    token: tokens[ChainId.BSC].fil,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xE1e0391c65edB42b148ce38EdEEBFE798a1bd23b',
    stakingServiceAddress: '0xeE592183FA309514AC60bAf88a04C5F6a5b96C25',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 119,
    token: tokens[ChainId.BSC].alpaca,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x217D3ab93AaAB28e84c1C11bb893882B957D294b',
    stakingServiceAddress: '0x1b7D690E979363f9C066b3E0D8E9b297f0a5070a',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 120,
    token: tokens[ChainId.BSC].ltc,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x97B109358710f88b9629a5cCf77a8aCb695D821C',
    stakingServiceAddress: '0x12DC843acA23F0c82Bde84098315cb9D8b56cb8c',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 121,
    token: tokens[ChainId.BSC].gmt,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xfF8c35AA0a4B8D0B7708597835046fF812D569AC',
    stakingServiceAddress: '0x278b42a731A18d715C4Fb989d59E159Bf46a8EAD',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 122,
    token: tokens[ChainId.BSC].gst,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x1Ed53829FAb9ba76114b9a8cBdeF143CdbCB18Ec',
    stakingServiceAddress: '0x119cc1B54bA94B720Ed7caA45661959Ae46648A2',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 123,
    token: tokens[ChainId.BSC].xrp,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x95569fFF9B815483De479736986495144f32d180',
    stakingServiceAddress: '0xd5253Dee4CCC54f2C06fE803298e3B2706760D77',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 124,
    token: tokens[ChainId.BSC].uni,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x5Fced076C6e42D5b988845Dbc57F70Abd5C5C699',
    stakingServiceAddress: '0x9b8bA051D3746Fd7DF5aABef63e377785E54C1a1',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 125,
    token: tokens[ChainId.BSC].twt,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x0be86103b53618653d6aCA420004eFC5FefA611F',
    stakingServiceAddress: '0x85E2d11E6a7E10e819d8f98374FCb2b2ACc4D8C3',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 126,
    token: tokens[ChainId.BSC].avax,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x1da8b1aD522EaFFF6B134E46F6dEdd397Fc4F76C',
    stakingServiceAddress: '0x4C39f831b196b50eA0A6f882df3Ae53e6c490c1D',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 127,
    token: tokens[ChainId.BSC].atom,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xcc818e466A7A0A37F4172Bd03FDbf8dE9366305a',
    stakingServiceAddress: '0x41239cc2DDD7B6D475F6074bb6fd711f274E0dc4',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 128,
    token: tokens[ChainId.BSC].near,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x42148F79E437c1d2E09ac6B4a23E3Afa95Af626f',
    stakingServiceAddress: '0x63ca42a4F79F5068d1892Cc9936e864a1e115326',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 129,
    token: tokens[ChainId.BSC].mana,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x47362fEF126Fdc006A458f7a0499A67926cF8126',
    stakingServiceAddress: '0x61959dc0614A5851bC02AAC01b1cF305800D4609',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 130,
    token: tokens[ChainId.BSC].sand,
    quoteToken: tokens[ChainId.BSC].usdc,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xb82E4FEbA86011eE47f81C8Ae108493fE0F7DCFF',
    stakingServiceAddress: '0xA986bE75070d70a53B555FD09e4C191F1058b801',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 131,
    token: tokens[ChainId.BSC].ftm,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x9025148363AD61ac04ecA31e89A086236f8F72c8',
    stakingServiceAddress: '0xFd71d76d995b9dff4dd5AEA8C4C8598DB9CD27C2',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 132,
    token: tokens[ChainId.BSC].cake,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x0c9FA735DbC788E28437a076B51e6B61b238f973',
    stakingServiceAddress: '0x427f5a9E5dF14b81cae21aBcBc55116e079B0Da5',
    created: new Date(2022, 5, 16).getTime(),
    finished: false,
    version: FactoryVersion.V1,
  },
  {
    pid: 133,
    token: tokens[ChainId.BSC].etc,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x9608e52AaDd1447bb326200Fd84682298c650ffC',
    stakingServiceAddress: '0xd4c5F6F38b0096835BE82B809A6382d422968ebb',
    created: new Date(2022, 5, 16).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 134,
    token: tokens[ChainId.BSC].mdao,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x3a02aA27eA386e2281132ecf499E8881b0Da4Eb7',
    stakingServiceAddress: '0x5657563CFDcEddA7CD5ea5fA02423C4D7Ce96bEB',
    created: new Date(2022, 7, 31).getTime(),
    finished: true,
    version: FactoryVersion.V1,
  },
  {
    pid: 201,
    token: tokens[ChainId.BSC].busd,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x3A667100753cFb7538208Af98Cb472F65F10Da87',
    stakingServiceAddress: '0x2b530D7243C126aaA71D70250f03A76322444a7b',
    finished: true,
    version: FactoryVersion.V2,
    migrateFrom: 101,
  },
  {
    pid: 202,
    token: tokens[ChainId.BSC].usdc,
    quoteToken: tokens[ChainId.BSC].usdt,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0x1e40450F8E21BB68490D7D91Ab422888Fb3D60f1',
    stakingServiceAddress: '0x85e3Fa9DD14f9Ed7D33f89E918fa7FE1A639933B',
    finished: false,
    version: FactoryVersion.V2,
    migrateFrom: 102,
  },
  {
    pid: 203,
    token: tokens[ChainId.BSC].usdc,
    quoteToken: tokens[ChainId.BSC].busd,
    earningToken: tokens[ChainId.BSC].nmx,
    lpAddress: '0xca25F030A103bcd0A6360FFe0F98D95F3CC6A7eC',
    stakingServiceAddress: '0x283567a552aAf8509d616D0F904A18439437cE34',
    created: new Date(2022, 10, 2).getTime(),
    finished: true,
    version: FactoryVersion.V2,
  },
].map(serializeFarm)

export default farms
